import { Record, List } from 'immutable';

import Hydrator from 'utils/Hydrator';

import { CourseProgressType } from 'enums/course-progress-type';
import { formatMinutes } from 'utils/DateHelper';

import LessonModel from './LessonModel';

const CourseModuleRecord = Record({
  id: 0,
  title: '',
  description: '',
  progress: 0,
  totalTimeInMinutes: 0,
  remainderTimeInMinutes: 0,
  lessonsCompleted: 0,
  lessons: List(),
  completedAt: new Date(),
});

export default class CourseModule extends CourseModuleRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {
      lessons: Hydrator.fromList(LessonModel.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CourseModule(hydrated);
  }

  get lessonsCount() {
    return this.lessons.size;
  }

  get completePercentage() {
    return Math.round((this.lessonsCompleted / this.lessonsCount) * 100);
  }

  getTotalTimeFormatted() {
    return formatMinutes(this.totalTimeInMinutes);
  }

  getRemainderTimeFormatted() {
    return formatMinutes(this.remainderTimeInMinutes);
  }

  getDisplayTime() {
    return this.isStarted() ? this.getRemainderTimeFormatted() : this.getTotalTimeFormatted();
  }

  isNotStarted() {
    return this.progress === CourseProgressType.notStarted;
  }

  isStarted() {
    return this.progress === CourseProgressType.started;
  }

  isCompleted() {
    return this.progress === CourseProgressType.completed;
  }

  getTotalLessonsStarted() {
    return this.lessons.filter((lesson) => lesson.isStarted()).size;
  }

  getTotalLessonsCompleted() {
    return this.lessons.filter((lesson) => lesson.isCompleted()).size;
  }

  getNextLessonId() {
    return this.lessons.find((lesson) => lesson.isNotStarted())?.id;
  }
}
